export default __webpack_public_path__ + "static/kursk-db36ac8414f763bb583371d635dfe8b2.jpg";